import React, { useEffect, useMemo, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Buttons from "../../UI/Buttons";
import FormInputFields from "../../FormInputFields";
import { ErrorBlock } from "../../../hoc/FormInput";
import { isSet } from "../../../Utils/CommonFunctions";
import ScmFormInputWrapper from "./ScmFormInputWrapper";

/**
 * Pages table Group Edit — same modal UX as layout GroupEditForm, but Value
 * uses pages ScmFormInputWrapper so Lookup fill (Weight/UOM/dims/Description)
 * matches cell-level Packages selection.
 */
const PagesGroupEditForm = (props) => {
  const {
    closePopupToogle,
    saveHandler,
    Fields,
    updatePayload,
    payload,
    fieldNodes,
    formName,
    defProps,
    elmtParams,
    rowVarName,
    onValueChange,
  } = props;

  const [validation, setValidation] = useState({});

  const selectedFieldNode = useMemo(() => {
    const type = payload && payload.type;
    if (!type) return null;
    return (fieldNodes || []).find(
      (node) => node && node.attribs && node.attribs.name === type
    );
  }, [fieldNodes, payload]);

  const field = {
    type: "PickList",
    label: "Package Type",
    isDefault: true,
    violation_name: "type",
    value: payload.type,
    options: [
      { value: "-None-", id: "" },
      ...(Fields || [])
        .filter((item) => item.access_mode !== "HIDDEN")
        .map((item) => ({
          value: item.label.blocks[0].text,
          id: item.id,
        })),
    ],
    attributes: {
      className: "form-control mandatory",
    },
    changeHandler: (val) => {
      updatePayload({ type: val, value: "" });
      setValidation((prev) => ({ ...prev, type: "" }));
    },
  };

  const hasValue = (val) => {
    if (val == null || val === "") return false;
    if (typeof val === "object") {
      if (val.displayValue != null && String(val.displayValue).trim() !== "") {
        return true;
      }
      if (val.label != null && String(val.label).trim() !== "") {
        return true;
      }
      if (val.selectedValue != null && String(val.selectedValue).trim() !== "") {
        return true;
      }
      if (val.value != null && String(val.value).trim() !== "") {
        return true;
      }
      return false;
    }
    return String(val).trim() !== "";
  };

  const validateForm = () => {
    const newValidation = {};
    let isBasicError = false;
    if (!payload?.type || !String(payload.type).trim()) {
      isBasicError = true;
      newValidation.type = "Package Type is required";
    }
    if (!hasValue(payload?.value)) {
      isBasicError = true;
      newValidation.value = "Value is required";
    }
    setValidation(newValidation);
    if (!isBasicError) {
      saveHandler();
    }
  };

  useEffect(() => {
    if (validation.value) {
      setValidation((prev) => ({ ...prev, value: "" }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload.value]);

  // Clear Value when Package field changes (layout GroupEditForm parity)
  const prevTypeRef = useRef(payload.type);
  useEffect(() => {
    if (prevTypeRef.current === payload.type) {
      return;
    }
    prevTypeRef.current = payload.type;
    updatePayload({ type: payload.type, value: "" });
    if (validation.value) {
      setValidation((prev) => ({ ...prev, value: "" }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload.type]);

  const buttonList = [
    {
      attributes: {
        className: "btn border-default btn-border mr-2 cursor-pointer",
      },
      clickHandler: () => closePopupToogle(),
      name: "Cancel",
    },
    {
      attributes: {
        className: "btn primary_bg cursor-pointer",
      },
      clickHandler: () => validateForm(),
      name: "Save",
    },
  ];

  const valueFormData = useMemo(() => {
    const fieldName = payload.type;
    if (!fieldName) return [{}];
    return [{ [fieldName]: payload.value || "" }];
  }, [payload.type, payload.value]);

  const handleNestedValueChange = (fieldName, value) => {
    if (typeof onValueChange === "function") {
      onValueChange(fieldName, value);
    }
  };

  const compactNode = selectedFieldNode
    ? {
        ...selectedFieldNode,
        attribs: {
          ...(selectedFieldNode.attribs || {}),
          withlabel: "false",
          inputOnly: "true",
          class: selectedFieldNode.attribs?.class || "form-control",
        },
      }
    : null;

  return (
    <Modal size="md" show={true} style={{ zIndex: 1050 }}>
      <Modal.Header>
        <h4 className="nav nav-pills navcrm-primary nav-pills-no-bd">
          Group Edit
        </h4>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label> Package </label>
          <div className="input-group">
            <FormInputFields {...field} />
          </div>
          <ErrorBlock message={isSet(validation.type, "")} />
        </div>
        <div className="form-group">
          <label> Value </label>
          <div className="input-group" style={{ overflow: "visible" }}>
            {compactNode ? (
              <ScmFormInputWrapper
                inputChild={compactNode}
                formName={formName}
                divIndex={0}
                formData={valueFormData}
                handleNestedInputChange={handleNestedValueChange}
                elmtParams={{
                  ...(elmtParams || {}),
                  scmVarName: rowVarName || "row",
                  dynamicVar: {
                    ...((elmtParams && elmtParams.dynamicVar) || {}),
                    [rowVarName || "row"]: {
                      ...(valueFormData[0] || {}),
                      loopIndex: 0,
                    },
                  },
                }}
                defProps={defProps}
                layoutCell={false}
              />
            ) : (
              <input
                type="text"
                className="form-control"
                disabled
                placeholder="Select a field"
              />
            )}
          </div>
          <ErrorBlock message={isSet(validation.value, "")} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Buttons buttonList={buttonList} />
      </Modal.Footer>
    </Modal>
  );
};

export default PagesGroupEditForm;
